import useAxios from "axios-hooks";
import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import ProfileStationsPricing from "../components/ProfileStationsPricing";

const StationsPricing = ({ id }) => {
  const [stationData, setStationData] = useState(null);
  const [{ data, loading, error }, execute] = useAxios(
    {
      url: `/api/userprofiles/${id}/stationinfos`,
      method: "GET",
    },
    { manual: true }
  );

  const fetchStations = async () => {
    try {
      const res = await execute();
      setStationData(res.data.data);
    } catch (err) {
      if (err?.code === "ERR_CANCELED") return;
      console.error("Error fetching station data:", err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchStations();
    }
  }, [id]);

  if (loading) {
    return (
      <Flex justify="center" align="center" minH="400px">
        <Spinner
          size="xl"
          color="brand.500"
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
        />
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex justify="center" align="center" minH="400px">
        <Box textAlign="center">
          <Text fontSize="lg" color="red.500" fontWeight="600" mb={2}>
            Error loading station data
          </Text>
          <Text fontSize="sm" color="gray.500">
            {error?.response?.data?.error || "Please try again later"}
          </Text>
        </Box>
      </Flex>
    );
  }

  return <ProfileStationsPricing id={id} data={stationData} onRefresh={fetchStations} />;
};

export default StationsPricing;
